export const AGENT_ITEMS = [
  {
    title: 'Agent Dashboard',
    icon: 'mdi-view-dashboard',
    routeName: 'dashboard',
    role: null,
  },
  {
    title: 'Clients',
    icon: 'mdi-account-multiple',
    routeName: 'clients',
    role: null,
  },
  {
    title: 'Households',
    icon: 'mdi-home',
    routeName: 'households',
    role: null,
  },
  /*{
    title: 'Policies',
    icon: 'mdi-file-document-multiple-outline',
    link: 'policies',
  },*/
  {
    title: 'Jump Start',
    icon: 'mdi-school',
    routeName: 'jump-start',
    role: null,
  },
  {
    title: 'Tools',
    icon: 'mdi-tools',
    routeName: 'tools',
    role: null,
  },
];

export const PARTNERSHIP_ADMIN_ITEMS = [
  {
    title: 'Admin Dashboard',
    icon: 'mdi-desktop-mac-dashboard',
    routeName: 'partnership-admin-dashboard',
    role: ['partnershipAdmin', 'employee']
  },
  {
    title: 'Agents',
    icon: 'mdi-account-tie',
    routeName: 'partnership-admin-agents',
    role: ['partnershipAdmin', 'employee'],
  },
];

export const SYSTEM_ADMIN_ITEMS = [
  {
    title: 'Manage Settings',
    icon: 'mdi-cash-multiple',
    routeName: 'system-admin-general',
    role: 'systemAdmin'
  },
  {
    title: 'Manage Admins',
    icon: 'mdi-account',
    routeName: 'system-admin-admins',
    role: 'systemAdmin'
  },
  {
    title: 'Manage Partnerships',
    icon: 'mdi-handshake',
    routeName: 'system-admin-partnerships',
    role: 'employee'
  },
  // Manage Agents ?
  {
    title: 'Manage Affiliates',
    icon: 'mdi-currency-usd',
    routeName: 'system-admin-affiliates',
    role: 'systemAdmin'
  },
  {
    title: 'Manage Clients',
    icon: 'mdi-account-multiple',
    routeName: 'system-admin-clients',
    role: 'systemAdmin'
  },
  {
    title: 'Manage Households',
    icon: 'mdi-home',
    routeName: 'system-admin-households',
    role: 'systemAdmin'
  },
  {
    title: 'Manage Jump Start',
    icon: 'mdi-cog',
    routeName: 'system-admin-jump-start',
    role: 'systemAdmin'
  },
];